import React from "react";
import { DisplayContentProps } from "../types";
import { displayContentContainer } from "../styles";

const DisplayContent: React.FC<DisplayContentProps> = ({
    currentContent,
    direction = "vertical",
    contentHeight = "auto"
}) => {
    return (
        <div css={displayContentContainer(direction, contentHeight)}>
            {currentContent.content}
        </div>
    );
};

export default DisplayContent;
